import { useEffect } from 'react';

export const useCalculateFetchedItems = (filteredCount, setFetched, recordHeight = 380, pageOffset = 215, columns = 1) => {
  useEffect(() => {
    // Calculate the number of fetched items depending on the screen height when the component mounts
    const calculatedValue = (Math.floor((window.innerHeight - pageOffset) / recordHeight) + 1) * columns;
    // Ensure the calculated value does not exceed the filtered count
    const finalValue = Math.min(calculatedValue, filteredCount);
    setFetched(finalValue);
  }, [filteredCount, setFetched, recordHeight, pageOffset, columns]);
};